//进口单
const orderData = {
  Id: 0,
  boxLines: [
    {
      rowList: [
        {
          title: "单号：",
          banding: "Code",
          value: "",
          dataType: "String",
          className: "c-code-color",
        },
        { title: "订单日期：", banding: "CreatedAt", value: "", dataType: "Date", className: "" },
      ],
    },
    {
      rowList: [
        {
          title: "结算类型：",
          banding: "PaymentType",
          initValue: "",
          value: "",
          dataType: "Type",
          dataMap: { 1: "T.T(转账)", 2: "COD(支票结算)", 3: "不付货款", 4: "其他方式" },
          classMap: { 1: "c-one-color ", 2: "c-two-color", 3: "c-three-color", 4: "c-four-color" },
        },
      ],
    },
    {
      rowList: [
        {
          title: "订单金额：",
          banding: "Amount",
          value: "",
          dataType: "Number",
          className: "c-amount-color",
        },
        {
          title: "未付汇金额： ",
          banding: "UnPaymentInvoiceAmount",
          value: "",
          dataType: "String",
          className: "c-unAmount-color",
        },
      ],
    },

    {
      rowList: [
        { title: "关税：", banding: "TariffAmount", value: "", dataType: "Number" },
        { title: "币别：", banding: "CurrencyType", value: "", dataType: "String" },
      ],
    },

    {
      rowList: [{ title: "供应商: ", banding: "SupplierName", value: "", dataType: "String" }],
    },
    {
      rowList: [
        {
          title: "状态： ",
          banding: "Status",
          value: "",
          dataType: "Type",
          dataMap: { 0: "未提交", 1: "待审核", 2: "已审核", 4: "已退回" },
          classMap: {
            0: "c-unSubmit-color",
            1: "c-unAudit-color",
            2: "c-audit-color",
            4: "c-back-color",
          },
        },
        {
          title: "付汇状态：",
          banding: "PaymentInvoiceStr",
          value: "",
        },
      ],
    },
    {
      rowList: [
        { title: "收货时间：", banding: "ReceivedAt", value: "", dataType: "Date", className: "" },
        { title: "送货时间：", banding: "DeliveryAt", value: "", dataType: "Date", className: "" },
      ],
    },
    {
      rowList: [
        { title: "报关时间：", banding: "CustomsAt", value: "", dataType: "Date", className: "" },
      ],
    },
  ],
};

// 本港单
const HKOrderData = {
  Id: 0,
  boxLines: [
    {
      rowList: [
        { title: "单号：", banding: "OrderNo", value: "", className: "c-code-color" },
        { title: "订单日期：", banding: "CreatedAt", value: "", dataType: "Date" },
      ],
    },
    {
      rowList: [
        {
          title: "操作模式：",
          banding: "HandleSchema",
          value: "",
          dataType: "Type",
          dataMap: { 1: "中港配送", 2: "长期租仓" },
          classMap: { 1: "c-one-color ", 2: "c-two-color" },
        },
        { title: "商务：", banding: "BusinessUserName", value: "" },
      ],
    },
    {
      rowList: [
        { title: "订单件数：", banding: "PackageCount", value: "" },
        { title: "订单重量：", banding: "TotalWeight", value: "" },
      ],
    },
    {
      rowList: [{ title: "供应商: ", banding: "SupplierName", value: "" }],
    },
    {
      rowList: [
        {
          title: "订单状态: ",
          banding: "Status",
          value: "",
          dataType: "Type",
          dataMap: { 0: "待提交", 1: "待审核", 2: "已审核", 3: "已退回" },
          classMap: {
            0: "c-unSubmit-color",
            1: "c-unAudit-color",
            2: "c-audit-color",
            3: "c-back-color",
          },
        },
      ],
    },
    {
      rowList: [
        {
          title: "入仓状态: ",
          banding: "InWarehouseStatus",
          value: "",
          dataType: "Type",
          dataMap: { 1: "未入仓", 2: "已入仓" },
          classMap: {
            1: "c-one-color",
            2: "c-two-color",
          },
        },
        {
          title: "出仓状态: ",
          banding: "OutWarehouseStatus",
          value: "",
          dataType: "Type",
          dataMap: { 1: "未出仓", 2: "已出仓", 3: "部分出仓" },
          classMap: {
            1: "c-one-color",
            2: "c-two-color",
            3: "c-three-color",
          },
        },
      ],
    },
  ],
};

// 出库单
const HKStockData = {
  Id: 0,
  boxLines: [
    {
      rowList: [
        { title: "出库单号: ", banding: "Code", value: "", className: "c-code-color" },
        { title: "订单日期: ", banding: "CreatedAt", value: "", dataType: "Date" },
      ],
    },
    {
      rowList: [
        { title: "本港单号: ", banding: "AgentOrderNo", value: "", className: "c-one-color" },
        { title: "出库时间: ", banding: "StockOutDate", value: "", dataType: "Date" },
      ],
    },
    {
      rowList: [
        { title: "件数: ", banding: "PartNo", value: "", className: "c-amount-color" },
        { title: "重量: ", banding: "Brand", value: "", className: "c-unAmount-color" },
      ],
    },
    {
      rowList: [
        { title: "卡板数: ", banding: "SnapGuage", value: "", className: "c-amount-color" },
        { title: "体积: ", banding: "Volume", value: "", className: "c-unAmount-color" },
      ],
    },
    {
      rowList: [{ title: "送货地址: ", banding: "DeliveryAddress", value: "" }],
    },

    {
      rowList: [
        {
          title: "操作状态: ",
          banding: "OperateStatus",
          value: "",
          dataType: "Type",
          dataMap: {
            1: "待提交",
            2: "待商务审核",
            3: "待香港仓库登记",
            4: "待确认出库",
            5: "退回",
            6: "香港确认出库",
          },
          classMap: {
            1: "c-one-color",
            2: "c-two-color",
            3: "c-three-color",
            4: "c-four-color",
            5: "c-back-color",
            6: "c-audit-color",
          },
        },
      ],
    },
    {
      rowList: [
        {
          title: "单据状态: ",
          banding: "Status",
          value: "",
          dataType: "Type",
          dataMap: { 0: "待提交", 1: "待审核", 2: "已审核" },
          classMap: { 0: "c-unSubmit-color", 1: "c-unAudit-color", 2: "c-audit-color" },
        },
        {
          title: "出库状态: ",
          banding: "StockOutStatus",
          value: "",
          dataType: "Type",
          dataMap: { 0: "未出仓", 1: "已出仓" },
          classMap: {
            0: "c-one-color",
            1: "c-two-color",
          },
        },
      ],
    },
    {
      rowList: [{ title: "退回原因: ", banding: "BackReason", value: "" }],
    },
  ],
};
const OcrList = {
  Id: 0,
  boxLines: [
    {
      rowList: [
        {
          title: "订单: ",
          banding: "OrderNo",
          value: "",
          className: "c-code-color",
          classNameBinding: "IsCustom",
          classMap: { true: "custom-order", false: "system-order" },
        },
        { title: "订单日期: ", banding: "CreatedAt", value: "", dataType: "Date" },
      ],
    },
    {
      rowList: [
        { title: "物料数：", banding: "Line", value: "", className: "c-amount-color" },
        { title: "照片数：", banding: "Photo", value: "", className: "c-amount-color" },
      ],
    },
  ],
};

// {
//   boxLines: [
//     {
//       rowList: [
//         { title: "单号：", banding: "OrderNo", value: "", className: "c-code-color" },
//         { title: "订单日期：", banding: "CreatedAt", value: "", dataType: "Date" },
//       ],
//     },
//     {
//       rowList: [
//         { title: "订单行数", banding: "OrderNo", value: "", className: "c-code-color" },
//         { title: "订单日期：", banding: "CreatedAt", value: "", dataType: "Date" },
//       ],
//     },
//   ],
// };

export { orderData, HKOrderData, HKStockData, OcrList };
